import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';
import 'next/stylesheets/tippy-tower-theme';

Component('tr-context-tooltip', {
  properties: {
    key: String,
    resourceType: String,
    resourceId: Number,
    showGuideUrl: String,
    logUrl: String,
  },

  mixins: [eventListenerMixin],

  connected() {
    this.anchorElement = this.getAnchorElement();
    if (!this.anchorElement) return;

    this.showTooltip();
    this.listenTo(this.anchorElement, 'click', this.handleAnchorClicked.bind(this));
  },

  disconnected() {
    this.stopListening();
  },

  beforeCache() {
    this.removeSelf();
  },

  removeSelf() {
    if (this.tippy) this.tippy.popper.remove();
    this.remove();
  },

  showTooltip() {
    const onTooltipShow = this.onTooltipShow.bind(this);
    this.tippy = tippy(this.anchorElement, {
      role: 'tooltip',
      theme: 'tower',
      maxWidth: 300,
      content: this.getTooltipContent(),
      trigger: 'manual',
      hideOnClick: false,
      animation: 'scale',
      duration: 400,
      delay: 1000,
      showOnCreate: true,
      allowHTML: true,
      interactive: true,
      zIndex: 7,
      appendTo: this.anchorElement,
      onShown: () => onTooltipShow(),
      onHidden: instance => instance.popper.remove(),
    });
    this.listenTo(this.tippy.popper.querySelector('.tooltip-ok'), 'click', this.handleOkClicked.bind(this));
  },

  sendShowApi() {
    $.ajax({
      type: 'POST',
      url: this.showGuideUrl,
      dataType: 'script',
    }).catch(e => console.log(e));
  },

  sendLogBehavior(action, extraValues = {}) {
    $.ajax({
      type: 'POST',
      url: this.logUrl,
      dataType: 'json',
      data: {
        resource_type: this.resourceType,
        resource_id: this.resourceId,
        behavior_action: `tr-context-tooltip:${action}`,
        extra_values: { name: this.key, ...extraValues },
      },
    }).catch(e => console.error(e));
  },

  onTooltipShow() {
    this.sendLogBehavior('show');
  },

  handleOkClicked(e) {
    e.preventDefault();
    e.stopPropagation();
    this.sendShowApi();
    this.hideAndDestroy();
    this.sendLogBehavior('clickok');
  },

  handleAnchorClicked() {
    this.sendShowApi();
    this.hideAndDestroy();
    this.sendLogBehavior('clickanchor');
  },

  hideAndDestroy() {
    try {
      this.tippy.hide();
    } finally {
      setTimeout(() => this.removeSelf(), 500);
    }
  },

  getAnchorElement() {
    const anchorSelector = this.getAttribute('anchor-selector');
    if (!anchorSelector || anchorSelector === 'document') {
      return null;
    }
    return document.querySelector(anchorSelector);
  },

  getTooltipContent() {
    return this.querySelector('template').content.cloneNode(true);
  },
});
